import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';
import { checkmarkIcon, lockIcon, logoutIcon, mailIcon, warningIcon, saveIcon } from '@deanone/dean-components';

const state = {
    personTypes: [],
    loadOverlay: false,
    meta: [],
    lastLoadedTable: '',
    tableStates: {},
    notification: {
        // SHOW NOTIFICATION
        show: false,
        type: {
            icon: warningIcon,
            text: 'Onbekende foutmelding',
            theme: 'warning',
        },
        messages: {
            standard: {
                icon: warningIcon,
                text: 'Onbekende foutmelding',
                theme: '',
            },
            // AUTH
            loginReject: {
                icon: lockIcon,
                text: 'Onjuiste combinatie van gebruikersnaam en wachtwoord.',
                theme: 'warning',
            },
            loginTokenReject: {
                icon: lockIcon,
                text: 'Uw link is verlopen of onjuist.',
                theme: 'warning',
            },
            logout: {
                icon: logoutIcon,
                text: 'U bent uitgelogd. U kunt opnieuw inloggen',
                theme: 'info',
            },
            // ACTIVATION
            activationRequest: {
                icon: mailIcon,
                text: 'U ontvangt binnen enkele seconden een activatie e-mail.',
                theme: 'success',
            },
            activatonRequestError: {
                icon: lockIcon,
                text: 'De combinatie van e-mailadres en klantnummer komt niet overeen of uw account is al geactiveerd.',
                theme: 'info',
            },
            activationExpired: {
                icon: lockIcon,
                text: 'Uw activatie link is verlopen.',
                theme: 'danger',
            },
            activationSuccess: {
                icon: checkmarkIcon,
                text: 'Uw account is geactiveerd.',
                theme: 'success',
            },
            // DATES
            dateInPast: {
                icon: warningIcon,
                text: 'U heeft een datum in het verleden gekozen.',
                theme: 'warning',
            },
            // HUNTGROUPS
            huntGroupCreateError: {
                icon: warningIcon,
                text: 'Belgroep kon niet worden aangemaakt.',
                theme: 'warning',
            },
            huntGroupEditError: {
                icon: warningIcon,
                text: 'Wijziging belgroep kon niet worden opgeslagen.',
                theme: 'warning',
            },
            huntGroupIdInvalid: {
                icon: warningIcon,
                text: 'Belgroep ID moet minstens 6 tekens lang zijn en mag geen !,%,&,@,#,$,^,*,? en ~ bevatten',
                theme: 'info',
            },
            // USERNAMES
            usernameEmpty: {
                icon: warningIcon,
                text: 'U heeft nog geen gebruikersnaam ingevoerd.',
                theme: 'info',
            },
            usernameUnknown: {
                icon: lockIcon,
                text: 'De ingevoerde gebruikersnaam is niet bij ons bekend.',
                theme: 'info',
            },
            // USER ID
            userIdInvalid: {
                icon: warningIcon,
                text: 'Gebruikersnaam moet minstens 6 tekens lang zijn en mag geen !,%,&,@,#,$,^,*,? en ~ bevatten',
                theme: 'info',
            },
            // USERS
            userCreateError: {
                icon: warningIcon,
                text: 'Gebruiker kon niet worden aangemaakt.',
                theme: 'warning',
            },
            userEditError: {
                icon: warningIcon,
                text: 'Gebruiker kon niet worden gewijzigd.',
                theme: 'warning',
            },
            // PASSWORDS
            passwordEmpty: {
                icon: lockIcon,
                text: 'U heeft nog geen wachtwoord ingevoerd.',
                theme: 'info',
            },
            passwordRepeat: {
                icon: warningIcon,
                text: 'Herhaal uw wachtwoord ter controle.',
                theme: 'info',
            },
            passwordReset: {
                icon: mailIcon,
                text: 'U ontvangt binnen enkele seconden een e-mail om uw wachtwoord te herstellen.',
                theme: 'success',
            },
            passwordActivated: {
                icon: checkmarkIcon,
                text: 'Uw nieuwe wachtwoord is geactiveerd.',
                theme: 'success',
            },
            passwordError: {
                icon: warningIcon,
                text: 'U kunt uw wachtwoord niet instellen vanwege een probleem.',
                theme: 'warning',
            },
            passwordNoMatch: {
                icon: warningIcon,
                text: 'Uw wachtwoorden komen niet overeen.',
                theme: 'info',
            },
            // PHONENUMBERS
            phoneNumberInvalid: {
                icon: warningIcon,
                text: 'U heeft een foutief extern nummer ingevoerd.',
                theme: 'warning',
            },
            clidPhoneNumberInvalid: {
                icon: warningIcon,
                text: 'U heeft een foutief uitgaand nummer ingevoerd.',
                theme: 'warning',
            },
            poneNumberExtensionInvalid: {
                icon: warningIcon,
                text: 'U heeft een foutief intern nummer ingevoerd.',
                theme: 'warning',
            },
            mobilePhoneNumberInvalid: {
                icon: warningIcon,
                text: 'U heeft een foutief telefoonnummer ingevoerd.',
                theme: 'warning',
            },
            // EMAIL
            emailEmpty: {
                icon: warningIcon,
                text: 'U heeft nog geen e-mailadres ingevoerd.',
                theme: 'info',
            },
            emailInvalid: {
                icon: warningIcon,
                text: 'U heeft een onjuist e-mailadres ingevoerd.',
                theme: 'info',
            },
            // CUSTOMER NUMBER
            customerNumberEmpty : {
                icon: warningIcon,
                text: 'U heeft nog geen klantnummer ingevoerd.',
                theme: 'info',
            },
            // FORM
            formFieldsEmpty : {
                icon: warningIcon,
                text: 'U heeft nog niet alle verplichte velden ingevuld.',
                theme: 'info',
            },
            // COMMON PHONES
            commonPhoneCreateError: {
                icon: warningIcon,
                text: 'Contact kon niet worden aangemaakt.',
                theme: 'warning',
            },
            // DEPARTMENT CREATE
            departmentCreateError: {
                icon: warningIcon,
                text: 'Afdeling kon niet worden aangemaakt.',
                theme: 'warning',
            },
            // DEPARTMENT CREATE
            locationCreateError: {
                icon: warningIcon,
                text: 'Locatie kon niet worden aangemaakt.',
                theme: 'warning',
            },
            // POSTAL CODE
            postalCodeInvalid: {
                icon: warningIcon,
                text: 'U heeft een onjuiste postcode ingevoerd.',
                theme: 'warning',
                title: 'Ongeldige postcode',
            },
            // GENERIC COULDN'T RECEIVE DATA
            couldNotReceiveData: {
                icon: warningIcon,
                text: 'Gegevens kunnen niet worden opgehaald, probeer het later opnieuw.',
                theme: 'danger',
                title: 'Fout',
            },
            // GENERIC PROVISIONING NOT AVAILABLE
            provisioningNotAvailable: {
                icon: warningIcon,
                text: 'Provisioning is momenteel niet beschikbaar. Probeer het later alstublieft!',
                theme: 'info',
            },
            // GENERIC COULDN'T SAVE DATA
            couldNotSaveData: {
                icon: warningIcon,
                text: 'Gegevens kunnen niet worden opgeslagen, probeer het later opnieuw.',
                theme: 'danger',
                title: 'Fout',
            },
            // GENERIC COULDN'T SEND DATA
            couldNotSendData: {
                icon: warningIcon,
                text: 'Gegevens kunnen niet worden verstuurd, probeer het later opnieuw.',
                theme: 'danger',
                title: 'Fout',
            },
            dataSaved: {
                icon: saveIcon,
                text: 'Gegevens zijn opgeslagen',
                theme: 'success',
                title: 'Opgeslagen',
            },
            odidoSubscriptionsImported: {
                icon: saveIcon,
                text: 'Odido-abonnementen zijn succesvol geïmporteerd.',
                theme: 'success',
                title: 'Opgeslagen',
            },
            refreshedPortingDate: {
                icon: saveIcon,
                text: 'De provisioning-porteringdatum is succesvol vernieuwd!',
                theme: 'success',
                title: 'Opgeslagen',
            },
            partitionTerminated: {
                icon: saveIcon,
                text: 'Je hebt de PBX-groep en de bijbehorende orderregels succesvol beëindigd.',
                theme: 'success',
                title: 'Opgeslagen',
            },
        },
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
